<template>
  <div class="dealers-view">
    <top-bar
      :title="dealer.name"
    />
    <scrollable-container>
      <div class="inner-dashboard">
        <el-row>
          <el-col :span="24">
            <div class="card animated fadeIn dealers-score">
              <el-row>
                <el-col :span="16">
                  <h5>Calificación del distribuidor</h5>
                  <star-rating
                    class="dealers-stars"
                    :score="branchScore.stars"
                  />
                </el-col>
                <el-col :span="8">
                  <div class="period-wrapper">
                    <el-form>
                      <el-form-item>
                        <el-select
                          v-model="currentPeriodId"
                          placeholder="Seleccione un periodo"
                          @change="onChangePeriod"
                        >
                          <el-option
                            v-for="period in periods"
                            :key="period.id"
                            :label="period.name"
                            :value="period.id"/>
                        </el-select>
                      </el-form-item>
                    </el-form>
                  </div>
                </el-col>
              </el-row>
            </div>
          </el-col>
        </el-row>

        <el-row
          type="flex"
          class="row interactive"
        >
          <el-col :span="16">
            <div class="card animated zoomIn">
              <h5>Áreas Evaluadas</h5>
              <div class="divisions-wrapper">
                <div
                  class="division-item"
                  :span="8"
                  v-for="divisionScore of dealerDivisionScores"
                  :key="divisionScore.id"
                >
                  <h6>{{ divisionScore.division }}</h6>
                  <star-rating :score="divisionScore.stars"/>
                </div>
              </div>
            </div>
          </el-col>
          <el-col :span="8">
            <div class="card animated zoomIn branches-card">
              <h5>Sucursales</h5>
              <h1>{{ pager.total }}</h1>
            </div>
          </el-col>
        </el-row>
      </div>
      <div class="padding-40">
        <ms-grid
          :data="branches"
          :columns="columns"
          :options="options"
          :pager="pager"
        >
          <span
            slot="type"
            slot-scope="{row}"
          >
            <span class="type">
              {{ row.type }}
            </span>
          </span>

          <star-rating
            slot-scope="{row}"
            slot="stars"
            :score="row.stars"
          />
        </ms-grid>
      </div>
    </scrollable-container>
  </div>
</template>

<script>
import { beforeEnter, beforeUpdate } from '@/guards/dealers.guards'
import TopBar from '@/components/top-bar'
import ScrollableContainer from '@/components/scrollable-container'
import MsGrid from '@/modules/grid/ms-grid'
import StarRating from '@/components/star-rating.vue'
import { mapGetters } from 'vuex'

export default {
  name: 'DealersView',
  components: {
    TopBar,
    ScrollableContainer,
    StarRating,
    MsGrid
  },
  data () {
    return {
      evaluationsLeft: 0,
      columns: [
        {
          label: 'Tipo',
          property: 'type',
          align: 'center'
        },
        {
          label: 'Nombre',
          property: 'name',
          filter (value) {
            return value || '-'
          },
          link (row) {
            return { name: 'branches-view', params: { id: row.id } }
          }
        },
        {
          label: 'Municipio',
          property: 'municipality',
          link (row) {
            return { name: 'branches-view', params: { id: row.id } }
          }
        },
        {
          label: 'Estado',
          property: 'state'
        },
        {
          label: 'Tipo',
          property: 'isMainBranch',
          filter (value) {
            return value ? 'Matriz' : 'Sucursal'
          }
        },
        {
          label: 'Calificación',
          property: 'stars',
          align: 'center'
        }
      ],
      options: {
        selectable: false
      },
      filter: [
        {
          label: 'El día de Hoy',
          value: 1
        },
        {
          label: 'Útimos siete dias',
          value: 2
        },
        {
          label: 'Último mes',
          value: 3
        }
      ],
      valueDone: 2,
      valueLeft: 2,
      valueSuccess: 2,
      currentPeriodId: null
    }
  },
  computed: {
    profile () {
      return this.$store.getters['profile/me']
    },
    branchScore () {
      return this.dealerScores[0] || {}
    },
    ...mapGetters('branches', {
      branches: 'items',
      pager: 'pagination'
    }),
    ...mapGetters('dealers', {
      dealer: 'item'
    }),
    ...mapGetters('periods', {
      periods: 'items'
    }),
    ...mapGetters('dealerScores', {
      dealerScores: 'items'
    }),
    ...mapGetters('branchScores', {
      branchScores: 'items'
    }),
    ...mapGetters('dealerDivisionScores', {
      dealerDivisionScores: 'items'
    })
  },
  mounted () {
    this.currentPeriodId = this.$store.getters['periods/currentId']
    this.updateBranchStars()
  },
  methods: {
    onChangePeriod () {
      let loader = this.$loading()
      let promises = []
      let branchIds = []
      for (let branch of this.branches) {
        branchIds.push(branch.id)
      }
      promises.push(
        this.$store
          .dispatch('branchScores/query', {
            'filters[where][periodId][eq]': this.currentPeriodId,
            'filters[whereIn][branchId]': branchIds
          })
          .then(this.updateBranchStars)
      )
      promises.push(
        this.$store.dispatch('dealerScores/query', {
          'filters[where][periodId][eq]': this.currentPeriodId,
          'filters[where][dealerId][eq]': this.dealer.id
        })
      )
      promises.push(
        this.$store.dispatch('dealerDivisionScores/query', {
          'filters[where][periodId][eq]': this.currentPeriodId,
          'filters[where][dealerId][eq]': this.dealer.id
        })
      )
      Promise.all(promises)
        .then()
        .finally(() => {
          loader.close()
        })
    },
    updateBranchStars () {
      for (let branch of this.branches) {
        branch.stars = 0
      }
      for (let branchScore of this.branchScores) {
        for (let branch of this.branches) {
          if (branch.id === branchScore.branchId) {
            branch.stars = branchScore.stars
          }
        }
      }
    }
  },
  beforeRouteEnter: beforeEnter,
  beforeRouteUpdate: beforeUpdate
}
</script>

<style lang="scss">
.dealers-view {
  .inner-dashboard {
    padding: 30px;

    .divisions-wrapper {
      display: flex;
      flex-wrap: wrap;
      margin-top: 20px;
      .division-item {
        width: 33%;
        min-width: 140px;
        display: flex;
        margin-top: 10px;
        h6 {
          width: 50%;
          text-align: right;
          margin-top: 0;
          margin-bottom: 20px;
        }
        .star-rating {
          width: 40%;
          margin-left: 20px;
        }
      }
    }

    .dealers-score {
      position: relative;
      padding: 30px;
      h5 {
        @include font-primary(14px, semibold);
        color: #444444;
        margin-bottom: 10px;
        margin-top: 0;
      }
      .dealers-stars {
        i {
          font-size: 18px;
          margin-right: 15px;
        }
      }
      .button-add {
        position: absolute;
        right: 30px;
        top: 30px;
      }
    }
  }
  .card {
    padding: 15px 20px;
    border-radius: 2px;
    border: 1px solid transparent;
    background-color: #fff;
    height: 100%;
    &.animated {
      animation-duration: 0.5s;
    }
    h5 {
      @include font-primary(14px, bold);
      color: #444444;
    }
    .dealers-card-options {
      width: 200px;
      input {
        @include font-primary(12px);
        color: #999999;
        border: none;
      }
    }
    h1 {
      @include font-primary(36px, light);
      color: $color-ui-primary;
    }
  }
  .interactive {
    .card {
      border-top: 1px solid rgba(221, 221, 221, 1);
      transition: all 0.3s ease-in-out;
      cursor: pointer;
      height: 190px;
      &:hover {
        z-index: 100;
        background-color: rgba(248, 248, 248, 1);
        border: 1px solid rgba(204, 204, 204, 1);
        box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
      }
    }
    .el-col:nth-child(1) .card {
      animation-delay: 0.1s;
    }
    .el-col:nth-child(2) .card {
      animation-delay: 0.2s;
    }
    .el-col:nth-child(3) .card {
      animation-delay: 0.3s;
    }
    .el-col:nth-child(2) {
      .card {
        border-left: 1px solid rgba(221, 221, 221, 1);
        border-right: 1px solid rgba(221, 221, 221, 1);
      }
    }
  }
  .table {
    tbody {
      tr {
        td {
          &:first-child {
            padding: 0 10px 0 0;
            background-color: transparent;
            width: 65px;
            span {
              background-color: #fff;
              display: block;
              height: 50px;
              vertical-align: middle;
              -webkit-border-radius: 4px;
              -moz-border-radius: 4px;
              border-radius: 4px;
            }
            .type {
              color: $color-ui-primary;
              display: inline-block;
              width: 20px;
              height: 20px;
              border-radius: 2px;
              border: 1px solid $color-ui-primary;
              vertical-align: middle;
              background-color: #fff;
              margin-top: 15px;
              line-height: 20px;
            }
          }
          &:nth-child(2) {
            border-radius: 4px 0 4px 0;
          }
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/app/dealers/dealers-view.vue